import { render, staticRenderFns } from "./activityEditExam.html?vue&type=template&id=04790464&scoped=true&external"
import script from "./activityEditExam.vue?vue&type=script&lang=js"
export * from "./activityEditExam.vue?vue&type=script&lang=js"
import style0 from "./activityEditExam.css?vue&type=style&index=0&id=04790464&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04790464",
  null
  
)

export default component.exports